import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

import * as errorUtils from '../../../modules/utility/global-utils';
import { CacheCountryService } from '../../../services/cacheCountries.service';
import { CountryApiService } from '../../petitioner/services/country.service';

import { Store } from '@ngrx/store';
import { LcaService } from 'src/app/services/lca.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AttorneyService } from 'src/app/services/attorney.service';
import { ConfirmationService } from "primeng/api";

@Component({
  selector: 'app-employer-information-lca',
  templateUrl: './employer-information-lca.component.html',
  styleUrls: ['./employer-information-lca.component.scss']
})
export class EmployerInformationLcaComponent implements OnChanges {

  @Input() userInfoForm: FormGroup;
  @Input() edituserInfoForm;

  formChangesSubscription: any;
  listCountry: any[];
  listStates: any[];
  panelOpenState: boolean = false;
  listCompany: any;
  listNaics: any;
  userInfo: any;
  companyListAssociatedWithAttorney = [];
  editUserInfo: any;
  editUserDataInfo: any;
  getNaicsCode: any;
  isDuplicateLCA: boolean = false;

  destroy$ = new Subject();
  userType: string = '';

  constructor(private apiService: CountryApiService,
              private cacheCountryService: CacheCountryService,
              private lcaApis: LcaService,
              private attorneyService: AttorneyService,
              private confirmationService: ConfirmationService,
              protected store: Store<any>) {
                this.userType = sessionStorage.getItem('userTypeRole');
              }

  ngOnChanges(changes: SimpleChanges){
    this.getCountries();
    const companyId = sessionStorage.getItem('companyId');
    if (companyId) {
      if(this.userType === 'Petitioner'){
        this.lcaApis.companyHierarchy(parseInt(companyId)).subscribe(data => {
          this.listCompany = data;
          if(this.listCompany){
              this.onLoadEmployerInfo(changes);
          }
        });
      }else if(this.userType === 'Attorney'){
        const payload = {
          searchText: "",
          searchCriteria: "",
          sortBy: "",
          sortOrder: "",
          pageNumber: 0,
          recordsPerPage: 0
        };
        this.attorneyService.getClientsList(parseInt(companyId),payload).subscribe(data => {
          this.listCompany = data['petetionerList'];
          if(this.listCompany){
            this.onLoadEmployerInfo(changes);
          }
        });
      }      
    }
  }

  ngOnInit(){
    this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
    // this.listNaics = [{id: 1, name: 'aaa'},{id: 2, name: 'bbb'},{id: 3, name: 'ccc'}];
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  getCountries(): void {
    this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data.listCountries.length > 0) {
        this.listCountry = data.listCountries;
      }
    });
  }

  onLoadEmployerInfo(changes){
    if(changes.edituserInfoForm.currentValue === "" && changes.edituserInfoForm.previousValue === undefined){
      if(JSON.parse(localStorage.getItem('userEfileInfo'))===null){
        const id = (this.userType ==='Petitioner' ? sessionStorage.getItem('companyId') : (this.listCompany ? this.listCompany[0]['petitionerId'] : null));
        this.setPeitionerCompanyFromAttorney(id);
      }
    } else if(changes.edituserInfoForm.currentValue.company.id){
      this.onChangeUserCompany();
    }
  }

  mappNaicsCode(){
    this.listNaics.forEach((item) => {
      item.naicsTitle = item.naicsCode+'--'+item.naicsTitle
    })
  }

  onChangeUserCompany(){
    this.editUserDataInfo = JSON.parse(localStorage.getItem('userEfileInfo')).employerInfo;
    this.getNaicsCode = JSON.parse(localStorage.getItem('userEfileInfo')).lcaApplication.companyNaicsCode;
      this.editUserInfo = {
        id: this.editUserDataInfo.company.id,
        // legalBusinessName: changes.edituserInfoForm.currentValue.legalBusinessName,
        hasTradeNameorDBA: this.editUserDataInfo.hasTradeNameorDBA,
        tradeNameOrDBA: this.editUserDataInfo.tradeNameOrDBA,
        address: [{
          addressLine1: this.editUserDataInfo.company.address?.length ? this.editUserDataInfo.company.address[0].addressLine1 : null,
          addressLine2: this.editUserDataInfo.company.address?.length ? this.editUserDataInfo.company.address[0].addressLine2 : null,
          id: this.editUserDataInfo.company.address?.length ? this.editUserDataInfo.company.address[0].id : null,
          countryCode: {
            countryCode: this.editUserDataInfo.company.address?.length &&  this.editUserDataInfo.company.address[0]?.countryCode ? this.editUserDataInfo.company.address[0].countryCode.countryCode : null,
          },
          stateProvinceCode: this.editUserDataInfo.company.address?.length ? this.editUserDataInfo.company.address[0].stateProvinceCode : null,
          city: this.editUserDataInfo.company.address?.length ? this.editUserDataInfo.company.address[0].city : null,
          postCode: this.editUserDataInfo.company.address?.length ? this.editUserDataInfo.company.address[0].postCode : null,
          stateProvinceName: this.editUserDataInfo.company.address?.length ? this.editUserDataInfo.company.address[0].stateProvinceName : null,
        }],
        phoneContacts: [{
          extension: this.editUserDataInfo.company.phoneContacts.length ? this.editUserDataInfo.company.phoneContacts[0].extension : null,
          phoneNo: this.editUserDataInfo.company.phoneContacts.length ? this.editUserDataInfo.company.phoneContacts[0].phoneNo : null,
        }],
        // naicsCode: this.editUserDataInfo.company.naicsCode,
        naicsCode: this.getNaicsCode,
        feiNo: this.editUserDataInfo.company.feiNo,
      }
      if(this.editUserDataInfo.company.id){
        this.userInfoDisplay(this.editUserInfo, this.editUserDataInfo.legalBusinessName);
      }
  }

  onChangeCompany(id: any): void {
    if(id){
      sessionStorage.setItem('currentCmpy', 'true');
      if(JSON.parse(localStorage.getItem('userEfileInfo'))){
        this.editUserDataInfo = JSON.parse(localStorage.getItem('userEfileInfo')).employerInfo;
        if(this.editUserDataInfo.company.id){
          if(parseInt(id) === this.editUserDataInfo.company.id){
            this.onChangeUserCompany();
          } else {
            this.setPeitionerCompanyFromAttorney(id);
          }
        }
      } else {
        this.setPeitionerCompanyFromAttorney(id);
      }
    }
  }

  setPeitionerCompanyFromAttorney(id: any): void {
    if(id){
      if(this.userType ==='Petitioner'){
        let data = this.listCompany.find(x => x.id === parseInt(id));
        this.userInfoDisplay(data, data.companyName);
      }else if(this.userType ==='Attorney'){
        this.lcaApis.getAttorneyCompanyList(parseInt(id)).subscribe(data=>{
          this.userInfoDisplay(data, data.companyName);
        });
      }
    }
  }

  onChangeNaics(id: any){
    this.listNaics.forEach((data)=> {
      if(data.naicsCode === id){
        this.userInfoForm.patchValue({
          companyNaicsCode: data.naicsCode,
          companyNaicsTitle: data.naicsTitle
        });
      }
    });
  }

  onChangeCountry(countryCode: any) {
    this.apiService.getStates(countryCode)
    .pipe(takeUntil(this.destroy$))
    .subscribe((states: any) => {
      if(states){
        this.listStates = states;
      }
    });
  }

  onChangeHasTradeNameorDBA(data) {
    if(data){
      this.userInfoForm.controls.tradeNameOrDBA.setValidators([Validators.required]);

    } else{
      this.userInfoForm.controls.hasTradeNameorDBA.setValue(false);
      this.userInfoForm.controls.tradeNameOrDBA.setValue(null);
      this.userInfoForm.controls.tradeNameOrDBA.clearValidators();
      
    }
    this.userInfoForm.controls.hasTradeNameorDBA.updateValueAndValidity();
    this.userInfoForm.controls.tradeNameOrDBA.updateValueAndValidity();
  }

  userInfoDisplay(userInfo, businessName){
    sessionStorage.setItem('currentCmpy', 'true'); 
    this.userInfoForm.reset();
    if(userInfo?.address?.length){
      this.onChangeCountry(userInfo.address[0].countryCode.countryCode);
    }
    // this.naicsListLoad(userInfo.id);
    
    let isUserEdit;
    let isUserEditStatus = true;
    if(isUserEditStatus){
      isUserEdit = {
        hasTradeNameorDBA: userInfo.hasTradeNameorDBA,
        tradeNameOrDBA: userInfo.tradeNameOrDBA
      }
      isUserEditStatus = false;
    }
    
    this.lcaApis.getCompanyNaics(userInfo.id).subscribe(data => {
      if(data==null){
        this.listNaics = [];
      } else {
        this.listNaics = data;
        this.mappNaicsCode();
      }

        let selectedNaicsCode;
        this.listNaics.forEach((data)=> {
          if(data.naicsCode === userInfo.naicsCode){
            selectedNaicsCode = data;
          }
        });
        this.userInfoForm.patchValue({
          companyName: userInfo.id,
          legalBusinessName: businessName,
          hasTradeNameorDBA: userInfo?.hasTradeNameorDBA,
          tradeNameOrDBA: userInfo.tradeNameOrDBA,
          addressLine1: userInfo?.address?.length ? userInfo.address[0].addressLine1 : null,
          addressLine2: userInfo?.address?.length ? userInfo.address[0].addressLine2: null,
          id: userInfo?.address?.length ? userInfo.address[0].id : null,
          country: userInfo?.address?.length ? userInfo.address[0].countryCode.countryCode : null,
          state: userInfo?.address?.length ? userInfo.address[0].stateProvinceCode : null,
          city: userInfo?.address?.length ? userInfo.address[0].city : null,
          postalCode: userInfo?.address?.length ? userInfo.address[0].postCode : null,
          stateProvinceName: userInfo?.address?.length ? userInfo.address[0].stateProvinceName : null,
          extension: userInfo?.phoneContacts?.length ? userInfo.phoneContacts[0]?.extension :null,
          telephone: userInfo?.phoneContacts?.length ? userInfo.phoneContacts[0]?.phoneNo : null,
          naicsCode: (selectedNaicsCode && selectedNaicsCode.naicsCode) ? selectedNaicsCode.naicsCode : null,
          companyNaicsCode: selectedNaicsCode ? selectedNaicsCode.naicsCode : null,
          companyNaicsTitle: selectedNaicsCode ? selectedNaicsCode.naicsTitle : null,
          feiNumber: userInfo.feiNo,
          isUserEdit: isUserEdit
        }); 

        if(!selectedNaicsCode && this.listNaics.length === 1){
          this.userInfoForm.patchValue({
            naicsCode: this.listNaics[0].naicsCode,
            companyNaicsCode: this.listNaics[0].naicsCode,
            companyNaicsTitle: this.listNaics[0].naicsTitle
          });
        }
        
        if(userInfo.hasTradeNameorDBA === null){
          this.onChangeHasTradeNameorDBA(false);
        } else {
          this.onChangeHasTradeNameorDBA(userInfo.hasTradeNameorDBA);
        }
    });
    
  }

  clearData() {
    // Clear any previous confirmation
    this.confirmationService.close();

    this.confirmationService.confirm({
      header: "Clear Data",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      acceptLabel: "Yes, Clear Data",
      acceptButtonStyleClass: "btn-accept-clear",
      rejectButtonStyleClass: "btn-cancel-clear",
      message: `<div class="mb-4"> This will clear all the data from this section. </div>
                <div class="mb-4"> Are you sure, you want to clear data? </div>`,
      accept: () => {
        this.userInfoForm.reset();
        this.confirmationService.close();
      },
      reject: () => {
        // Clear the confirmation dialog instance after rejection
       this.confirmationService.close();
     },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
